// Step 4 — icon sizing tokens. One vocabulary for every glyph in the app;
// no more magic width/height numbers scattered across components.
export const ICON_SIZE = {
  xs: 14, // inline text glyphs, badges
  sm: 16, // dense rows, chips
  md: 20, // nav glyphs, action rail, default UI icons
  lg: 24, // primary FABs, hero actions
  xl: 28, // oversized feature icons
};

export const ICON_STROKE = {
  thin: 1.2,    // nav glyphs (existing AppNav look)
  regular: 1.6, // action buttons
  bold: 2,      // emphasis / active states
};
